<div id="comment-list-container" >
    <div *ngFor="let comment of comments">
        <app-comment
        [comment] = 'comment'
        ></app-comment>
    </div>
</div>
